import React, { useCallback, useMemo, useState } from "react";
import "../sass/layout/_testimonials.scss";
import "../sass/layout/_sheVentures.scss";
import testimonials from "../static/data/testimonials.json";
import testimonial_1 from "../static/images/testimonial_1.jpeg";
import testimonial_2 from "../static/images/testimonial_2.jpeg";
import testimonial_3 from "../static/images/testimonial_3.png";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import LazyImage from "../components/LazyImage.js";

const IMAGES = [testimonial_1, testimonial_2, testimonial_3];

export const Testimonials = () => {
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const { width } = useWindowDimensions();

  // Handle manual testimonial selection
  const selectTestimonial = useCallback((index) => {
    setCurrentTestimonialIndex(index);
    setShowCardDetails(prevState => !prevState)
  }, []);

  const renderDetails = useMemo(() => {
    if (width < 600) return null;
    return (
      <div className="testimonial-details-container">
        <h2>{testimonials[currentTestimonialIndex].name}</h2>
        <h3>
          {testimonials[currentTestimonialIndex].trip}
        </h3>
        <p style={{ marginTop: "1rem" }}>{testimonials[currentTestimonialIndex].words}</p>
      </div>
    );
  }, [currentTestimonialIndex, width]);

  const renderMobileView = useMemo(() => {
    if (width > 600) return null;
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h1>Testimonials</h1>
        <div className="signature-journeys-container" style={{
          height: "65vh",
          cursor: "pointer"
        }}>
          <div className="sj-card-container" style={{ marginTop: 0, paddingBottom: "10px", overflowY: "hidden" }} id="scrollbar-style">
            {IMAGES.map((img, index) => {
              return (
                <div
                  key={index}
                  className="ventures-small-card"
                  style={{
                    margin: index % 2 === 0 ? "0rem 0 0 0" : "0rem 1.5rem 0 1.5rem",
                  }}
                  onClick={() => selectTestimonial(index)}
                >
                  {currentTestimonialIndex === index && showCardDetails ? (
                    <div style={{
                      width: "80vw", height: "60vh", borderRadius: "1rem",
                    }}>
                      <div className="ventures-description-container" style={{
                        border: "1px solid #97789b",
                        backgroundColor: "#97789b",
                        height: "60vh",
                        padding: "2rem",
                        borderRadius: "1rem",
                        boxShadow: "0 0.5rem 0.5rem rgba(0, 0, 0, 0.2)",
                        overflowY: "scroll"
                      }}>
                        <h2 style={{ color: "#fff" }}>{testimonials[currentTestimonialIndex].name}</h2>

                        <h3 style={{ marginTop: "1rem", fontSize: "1rem", lineHeight: "1.7rem", color: "#fff" }}>{testimonials[currentTestimonialIndex].words}</h3>
                      </div>
                    </div>

                  )
                    :
                    (
                      <div style={{ position: "relative" }}>
                        <LazyImage
                          imgOnly={true}
                          src={img}
                          alt={"WanderLuxe Testimonial"}
                          // className="ventures-main-img"
                          styleish={{
                            height: "60vh",
                            width: "80vw",
                            objectFit: "cover",
                            boxShadow: "0 0.5rem 0.5rem rgba(0, 0, 0, 0.2)",
                            borderRadius: "1rem"
                          }}
                        />
                        <h2 style={{ color: "#fff", position: "absolute", top: "0", padding: "2rem", fontFamily: "RalewayBold" }}>{testimonials[index].name}</h2>

                      </div>
                    )
                  }
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }, [currentTestimonialIndex, selectTestimonial, showCardDetails, width]);

  return (
    <div className="testimonials-container">
      {
        width > 600 && (
          <>
            <div className="testimonial-left">
              <div style={{ alignSelf: "flex-start" }}>
                {<h1 className="testimonials-heading">Testimonials</h1>}
                {renderDetails}
              </div>
              <div className="testimonial-left-image-container">
                {IMAGES.map((img, index) => {
                  if (index === currentTestimonialIndex) return null; // skip the active one
                  return (
                    <img
                      key={index}
                      alt={`testimonial ${index}`}
                      className="testimonial-left-image-container-img"
                      src={img}
                      onClick={() => selectTestimonial(index)}
                      style={{ cursor: 'pointer' }}
                    />
                  );
                })}
              </div>
            </div>
            <div
              className="testimonial-right"
              style={{ backgroundImage: `url(${IMAGES[currentTestimonialIndex]})` }}
            />
          </>
        )
      }

      {renderMobileView}
    </div>
  );
};
